import { Breadcrumbs, Button, Typography } from "@mui/material";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";
import { Link } from "react-router-dom";

function ModifyVehicle() {
  return (
    <div className="vehicle-form-page">
      <Breadcrumbs aria-label="breadcrumb" className="mb-3">
        <Link to="/">Home</Link>
        <Link to="/vehicles">Vehicles</Link>
        <Typography>Modify Vehicle</Typography>
      </Breadcrumbs>

      <section className="vehicles-hero">
        <div>
          <Typography className="vehicles-hero-eyebrow">
            <DirectionsCarFilledOutlinedIcon fontSize="inherit" />
            Vehicle editor
          </Typography>
          <Typography variant="h4" className="vehicles-hero-title">
            Select a vehicle to modify
          </Typography>
          <Typography className="vehicles-hero-subtitle">
            Open any vehicle from the catalogue to edit its details, images, and
            variant features.
          </Typography>
        </div>
      </section>

      <section className="section vf-section vf-empty-panel">
        <DirectionsCarFilledOutlinedIcon className="vf-empty-panel-icon" />
        <Typography variant="h6">No vehicle selected</Typography>
        <Typography color="text.secondary" className="mb-3">
          Choose a vehicle from the list, or add a new one to the catalogue.
        </Typography>
        <div className="d-flex gap-2 flex-wrap">
          <Button
            component={Link}
            to="/vehicles"
            variant="contained"
            startIcon={<ArrowBackIcon />}
          >
            Go to vehicles
          </Button>
          <Button component={Link} to="/add_vehicles" variant="outlined">
            Add new vehicle
          </Button>
        </div>
      </section>
    </div>
  );
}

export default ModifyVehicle;
